export default __webpack_public_path__ + "static/media/Nursepatient.1fecece4.svg";